import { Collapse, Icon } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { withIsMobile } from 'treeline-react-core-components/WindowSizeProvider';
import TitleScroller from '../Home/TitleScroller';
import ViewInListLink from '../UI/ViewInListLink';
import { useShelves } from './containers/ShelvesDataStore';
import ShelfType from './ShelfType';
import { useHistory } from 'react-router-dom';
import LocalStorageKeys from '../Preferences/LocalStorageKeys';
import { useYourBooksDrawer } from '../YourBooks/YourBooksDrawerContext';

const Panel = Collapse.Panel;

ShelvesCollapse.propTypes = {
	isMobile: PropTypes.func,
};

function ShelvesCollapse({ isMobile }) {
	const history = useHistory();
	const yourBooksDrawer = useYourBooksDrawer();

	const localStorageKey = LocalStorageKeys.expandedShelfPanels;
	const localStorageValue = localStorage.getItem(localStorageKey);

	const getShelfKeys = () => {
		return Object.keys(ShelfType).map(shelf => {
			return ShelfType[shelf].key;
		});
	};

	const [collapsedPanels, setCollapsedPanels] = React.useState(
		localStorageValue ? JSON.parse(localStorageValue) : getShelfKeys(),
	);
	const isMobileSize = isMobile();

	React.useEffect(() => {
		localStorage.setItem(localStorageKey, JSON.stringify(collapsedPanels));
	}, [collapsedPanels]);

	const shelvesDataStore = useShelves();
	const { isLoading, shelves } = shelvesDataStore.state;

	const getShelves = (shelves, shelfType, returnFullObject) => {
		shelves = shelves && shelves.filter(sh => sh.shelf === shelfType.key);

		if (!returnFullObject) {
			var shelfSkus = shelves.map(function(item) {
				return item.sku;
			});

			return shelfSkus;
		} else {
			return shelves;
		}
	};

	const renderPanel = shelfType => {
		const filteredShelves = getShelves(shelves, shelfType, true);
		return (
			filteredShelves &&
			filteredShelves.length > 0 && (
				<Panel
					style={{ marginLeft: '-10px' }}
					header={shelfType.longText}
					extra={filteredShelves.length}
					key={shelfType.key}>
					<TitleScroller
						titles={
							!isLoading && filteredShelves && filteredShelves
						}
						communityId={0}
					/>
					<div onClick={() => handleClick(shelfType.key)}>
						<ViewInListLink />
					</div>
				</Panel>
			)
		);
	};

	const handleClick = selectedKey => {
		shelvesDataStore.setSelectedMenuOption(selectedKey);
		history.push('/shelves');
		yourBooksDrawer && yourBooksDrawer.close();
	};

	const logChange = e => {
		setCollapsedPanels(e);
	};

	return (
		<>
			{shelves && shelves.length > 0 ? (
				<Collapse
					className={
						!isMobileSize
							? 'standard-collapse'
							: 'standard-collapse-mobile'
					}
					bordered={false}
					onChange={logChange}
					defaultActiveKey={collapsedPanels}
					activeKeys={collapsedPanels}
					expandIcon={({ isActive }) => (
						<Icon type="caret-right" rotate={isActive ? 90 : 0} />
					)}>
					{Object.keys(ShelfType).map(shelf => {
						return (
							ShelfType[shelf].doRenderInList &&
							renderPanel(ShelfType[shelf])
						);
					})}
				</Collapse>
			) : (
				<div className="no-content-text">
					Titles you add to your shelves will show up here
				</div>
			)}
		</>
	);
}

export default withIsMobile(ShelvesCollapse);
